export default __webpack_public_path__ + "static/media/prize3.504813c7.svg";